import React, { useContext, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  FormHelperText,
} from "@mui/material";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { useMutation, useQuery } from "@apollo/client";
//icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_EXPENSE_TYPE } from "../../Schema/ExpenseType";
import { translateLauguage } from "../../Function/Translate";
import CropImageFile from "../CropImage/CropImageFile";
import { UPDATE_EXPENSE_GROUP } from "../../Schema/ExpenseGroup";
import { useEffect } from "react";
import { SelectExpenseGroup } from "../Include/DynamicSelect";
export default function CreateExpenseType({ open, handleClose, setRefetch }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [groupExpenseVal, setGroupExpenseVal] = useState({ id: "", title: "" });
  const [createExpenseType] = useMutation(CREATE_EXPENSE_TYPE, {
    onCompleted: ({ createExpenseType }) => {
      setLoading(false);
      // console.log("createExpenseType::", createExpenseType);
      if (createExpenseType?.status === true) {
        setAlert(true, "success", createExpenseType?.message);
        handleClose();
        resetForm();
        setRefetch();
        setGroupExpenseVal({ id: "", title: "" });
      } else {
        setAlert(true, "error", createExpenseType?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const CreateExpenseType = Yup.object().shape({
    code: Yup.string().required("required!"),
    title: Yup.string().required("required!"),
    remark: Yup.string(),
    groupExpense: Yup.string().required("required!"),
  });

  const formik = useFormik({
    initialValues: {
      code: "",
      title: "",
      remark: "",
      groupExpense: "",
    },
    validationSchema: CreateExpenseType,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      createExpenseType({
        variables: {
          ...values,
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (groupExpenseVal?.id !== undefined || groupExpenseVal?.id !== "") {
      setFieldValue("groupExpense", groupExpenseVal?.id);
    }
  }, [groupExpenseVal]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {t("modal_title_create_expense_type")}
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">Code</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="code"
                  {...getFieldProps("code")}
                  error={Boolean(touched.code && errors.code)}
                  helperText={touched.code && errors.code}
                  multiline
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_select_expense_group")}
                </Typography>
                <SelectExpenseGroup
                  selectedVal={groupExpenseVal}
                  setSelectedVal={setGroupExpenseVal}
                  // className="select-role"
                />
                {!!errors.groupExpense && touched.groupExpense && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.groupExpense}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_title")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("label_title")}
                  {...getFieldProps("title")}
                  error={Boolean(touched.title && errors.title)}
                  helperText={touched.title && errors.title}
                  multiline
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_remark")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("label_remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
